//@ts-check
import {getCatalog} from '@/services/ProductsService/ProductCatalog/productCatalog'
import {useQuery} from '@tanstack/react-query'

/**
 * @returns {import('@tanstack/react-query').UseQueryResult<import('@/types/productCatalogTypes').ProductCategoriesData, Error>}
 */
export const useProductCatalogData = () => {
  return useQuery({
    queryKey: ['product-catalog-data'],
    queryFn: getCatalog,
  })
}
